// LumiCraft — scripts compartidos de las secciones propias
document.addEventListener('DOMContentLoaded', function () {
  initRevealLC();
  initContadoresLC();
  initGaleriaProductoLC();
  initVariantesProductoLC();
  initCantidadTarjetasLC();
  initVideoMotionLC();
  initCountdownLC();
  initOfertaProductoLC();
});

function initOfertaProductoLC() {
  var botones = document.querySelectorAll('[data-lc-boton-multi-agregar]');
  if (!botones.length) return;

  var primerBoton = botones[0];
  var checkboxes = document.querySelectorAll('[data-lc-addon-checkbox]');
  var basePrice = parseInt(primerBoton.getAttribute('data-base-price'), 10) || 0;
  var variantId = parseInt(primerBoton.getAttribute('data-variant-id'), 10);
  var errorBox = document.querySelector('[data-lc-add-error]');
  var qtyInputs = document.querySelectorAll('[data-lc-qty-input]');
  var qtyGroups = document.querySelectorAll('[data-lc-qty-stepper]');
  var cantidadActual = 1;

  var actualizarTotal = function () {
    var addonsTotal = 0;
    checkboxes.forEach(function (cb) {
      if (cb.checked) addonsTotal += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
    });
    var total = (basePrice * cantidadActual) + addonsTotal;
    botones.forEach(function (boton) {
      var precioSpan = boton.querySelector('[data-lc-boton-precio]');
      if (precioSpan) precioSpan.textContent = formatearDineroLC(total);
    });
  };

  var setCantidad = function (valor) {
    valor = parseInt(valor, 10);
    if (isNaN(valor) || valor < 1) valor = 1;
    cantidadActual = valor;
    qtyInputs.forEach(function (input) { input.value = cantidadActual; });
    actualizarTotal();
  };

  qtyGroups.forEach(function (grupo) {
    var input = grupo.querySelector('[data-lc-qty-input]');
    var decr = grupo.querySelector('[data-lc-qty-decr]');
    var incr = grupo.querySelector('[data-lc-qty-incr]');
    if (decr) decr.addEventListener('click', function () { setCantidad(cantidadActual - 1); });
    if (incr) incr.addEventListener('click', function () { setCantidad(cantidadActual + 1); });
    if (input) input.addEventListener('change', function () { setCantidad(input.value); });
  });

  checkboxes.forEach(function (cb) { cb.addEventListener('change', actualizarTotal); });
  actualizarTotal();

  var agregarAlCarrito = function (boton) {
    if (boton.disabled || boton.getAttribute('aria-disabled') === 'true') return;

    var items = [{ id: variantId, quantity: cantidadActual }];
    checkboxes.forEach(function (cb) {
      if (cb.checked) items.push({ id: parseInt(cb.getAttribute('data-addon-variant-id'), 10), quantity: 1 });
    });

    var cart = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    botones.forEach(function (b) {
      b.setAttribute('aria-disabled', 'true');
      b.classList.add('loading');
      var spinner = b.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    });
    if (errorBox) errorBox.setAttribute('hidden', '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (errorBox) {
            errorBox.textContent = response.description || response.message || 'Something went wrong. Please try again.';
            errorBox.removeAttribute('hidden');
          }
          return;
        }
        if (cart) {
          cart.renderContents(response);
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        if (errorBox) {
          errorBox.textContent = 'Network error. Please try again.';
          errorBox.removeAttribute('hidden');
        }
      })
      .finally(function () {
        botones.forEach(function (b) {
          b.removeAttribute('aria-disabled');
          b.classList.remove('loading');
          var spinner = b.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
      });
  };

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () { agregarAlCarrito(boton); });
  });

  var stickyBar = document.querySelector('[data-lc-sticky-bar]');
  if (stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('lc-mostrar', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(primerBoton);
  }
}

function initCountdownLC() {
  var els = document.querySelectorAll('[data-lc-countdown]');
  if (!els.length) return;

  els.forEach(function (el) {
    var horas = parseFloat(el.getAttribute('data-horas')) || 24;
    var duracionMs = horas * 60 * 60 * 1000;
    var storageKey = 'lc_deal_deadline_' + horas;
    var salida = el.querySelector('[data-lc-countdown-valor]');
    if (!salida) return;

    var deadline = parseInt(localStorage.getItem(storageKey), 10);
    var ahora = Date.now();
    if (!deadline || isNaN(deadline) || deadline <= ahora) {
      deadline = ahora + duracionMs;
      try { localStorage.setItem(storageKey, String(deadline)); } catch (e) {}
    }

    var pad = function (n) { return String(n).padStart(2, '0'); };

    var tick = function () {
      var restante = deadline - Date.now();
      if (restante <= 0) {
        deadline = Date.now() + duracionMs;
        try { localStorage.setItem(storageKey, String(deadline)); } catch (e) {}
        restante = duracionMs;
      }
      var h = Math.floor(restante / 3600000);
      var m = Math.floor((restante % 3600000) / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      salida.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    };

    tick();
    setInterval(tick, 1000);
  });
}

function initVideoMotionLC() {
  var videos = document.querySelectorAll('.lc-cole-video');
  if (!videos.length) return;
  var prefiereMenosMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  videos.forEach(function (v) {
    if (prefiereMenosMovimiento) {
      v.removeAttribute('autoplay');
      v.pause();
    }
  });
}

function initRevealLC() {
  var els = document.querySelectorAll('.lc-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('lc-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--lc-delay', Math.min(i % 6, 5) * 90 + 'ms');
    obs.observe(el);
  });
}

function initContadoresLC() {
  var els = document.querySelectorAll('[data-lc-contador]');
  if (!els.length) return;
  var animar = function (el) {
    var fin = parseFloat(el.getAttribute('data-lc-contador'));
    var decimales = el.getAttribute('data-lc-decimales') === '1' ? 1 : 0;
    var duracion = 1400;
    var inicio = null;
    var paso = function (ts) {
      if (!inicio) inicio = ts;
      var prog = Math.min((ts - inicio) / duracion, 1);
      var val = fin * (1 - Math.pow(1 - prog, 3));
      el.textContent = decimales ? val.toFixed(1) : Math.round(val).toLocaleString('es-ES');
      if (prog < 1) requestAnimationFrame(paso);
      else el.textContent = decimales ? fin.toFixed(1) : Math.round(fin).toLocaleString('es-ES');
    };
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animar(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProductoLC() {
  var wraps = document.querySelectorAll('[data-lc-galeria-producto]');
  wraps.forEach(function (wrap) {
    var principal = wrap.querySelector('[data-lc-galeria-principal]');
    var minis = wrap.querySelectorAll('[data-lc-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          principal.style.opacity = '1';
        }, 160);
        minis.forEach(function (m) { m.classList.remove('lc-mini-activa'); });
        mini.classList.add('lc-mini-activa');
      });
    });
  });
}

function initVariantesProductoLC() {
  var forms = document.querySelectorAll('[data-lc-producto-form]');
  forms.forEach(function (formWrap) {
    var variantesData = formWrap.querySelector('[data-lc-variantes-json]');
    var selects = formWrap.querySelectorAll('[data-lc-opcion]');
    if (!variantesData || !selects.length) return;
    var variantes;
    try { variantes = JSON.parse(variantesData.textContent); } catch (e) { return; }

    var actualizar = function () {
      var elegido = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === elegido[idx]; });
      });
      if (!variante) return;
      var inputId = formWrap.querySelector('input[name="id"]');
      var precioEl = formWrap.querySelector('[data-lc-precio]');
      var precioAntesEl = formWrap.querySelector('[data-lc-precio-antes]');
      var badgeAhorroEl = formWrap.querySelector('[data-lc-badge-ahorro]');
      var boton = formWrap.querySelector('[data-lc-boton-agregar]');
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDineroLC(variante.price);
      var tieneAhorro = variante.compare_at_price && variante.compare_at_price > variante.price;
      if (precioAntesEl) {
        if (tieneAhorro) {
          precioAntesEl.textContent = formatearDineroLC(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (badgeAhorroEl) {
        if (tieneAhorro) {
          var pct = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
          badgeAhorroEl.textContent = 'Save ' + pct + '%';
          badgeAhorroEl.style.display = '';
        } else {
          badgeAhorroEl.style.display = 'none';
        }
      }
      if (boton) {
        var textoSpan = boton.querySelector('[data-lc-boton-texto]');
        var precioSpan = boton.querySelector('[data-lc-boton-precio]');
        if (variante.available) {
          boton.disabled = false;
          if (textoSpan) textoSpan.textContent = boton.getAttribute('data-texto-disponible') || 'Add to Cart';
          if (precioSpan) precioSpan.textContent = formatearDineroLC(variante.price);
        } else {
          boton.disabled = true;
          if (textoSpan) textoSpan.textContent = boton.getAttribute('data-texto-agotado') || 'Sold Out';
          if (precioSpan) precioSpan.style.display = 'none';
        }
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function formatearDineroLC(centavos) {
  var valor = (centavos / 100).toFixed(2);
  return '$' + valor;
}

function initCantidadTarjetasLC() {
  var grupos = document.querySelectorAll('[data-lc-cantidad-grupo]');
  grupos.forEach(function (grupo) {
    var tarjetas = grupo.querySelectorAll('[data-lc-cantidad-opcion]');
    var inputCantidad = document.querySelector('[data-lc-cantidad-input]');
    tarjetas.forEach(function (t) {
      t.addEventListener('click', function () {
        tarjetas.forEach(function (o) { o.classList.remove('lc-cantidad-activa'); });
        t.classList.add('lc-cantidad-activa');
        if (inputCantidad) inputCantidad.value = t.getAttribute('data-lc-cantidad-opcion');
      });
    });
  });
}
